import AdminInviteAccess from "@/components/AdminInviteAccess";
import AdminAccessCodes from "@/components/AdminAccessCodes";
import AdminInviteList from "@/components/AdminInviteList";
import { useState } from "react";
import { UserPlus, KeyRound } from "lucide-react";

const STEPS = [
  { icon: UserPlus, title: "Invite one person", body: "Fill in their name and email, pick the speciality (e.g. Ofsted — Independent Fostering Agencies), choose plan and duration, then click Create account & send invite. They get a 7-day set-password link." },
  { icon: KeyRound, title: "Access code for a group", body: "Create a code with a speciality attached and share it. Anyone who registers with the code gets that speciality and plan automatically." },
];

export default function AdminLogins() {
  const [refreshKey, setRefreshKey] = useState(0);
  return (
    <div className="space-y-6" data-testid="admin-logins">
      <div className="grid sm:grid-cols-2 gap-4">
        {STEPS.map((s) => (
          <div key={s.title} className="rounded-2xl border border-border bg-secondary/40 p-4 flex gap-3" data-testid={`admin-logins-step-${s.title.split(" ")[0].toLowerCase()}`}>
            <div className="w-9 h-9 rounded-xl bg-primary/10 flex items-center justify-center shrink-0"><s.icon className="w-4 h-4 text-primary" /></div>
            <div><p className="font-semibold text-sm mb-1">{s.title}</p><p className="text-xs text-muted-foreground leading-relaxed">{s.body}</p></div>
          </div>
        ))}
      </div>
      <AdminInviteAccess onCreated={() => setRefreshKey((k) => k + 1)} />
      <AdminInviteList refreshKey={refreshKey} />
      <AdminAccessCodes />
    </div>
  );
}
